import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { analyticsPath, apiClient } from '@/lib/api-client';
import { adaptConnectedUsers, type ApiConnectedUsers } from '@/lib/analytics-adapters';
import type { ConnectedUsers } from '@/types/analytics';

import { analyticsKeys } from './analytics-keys';

export function useConnectedUsers(): UseQueryResult<ConnectedUsers, Error> {
  return useQuery({
    queryKey: analyticsKeys.connectedUsers(),
    queryFn: async ({ signal }) =>
      adaptConnectedUsers(
        await apiClient.get<ApiConnectedUsers>(analyticsPath('/connected-users'), signal),
      ),
    refetchInterval: 30_000,
  });
}
